// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"SocialMedia_iconContainer__2GcPC"};